<template>
  <div class="pageContol studentList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">考试管理</a>
          <i>></i>
          <a href="javascript:;" @click="$router.push({ path: '/web/examination/examHouse' })">考试仓管理</a>
          <i>></i>
          <a href="javascript:;" @click="$router.back()">考试设备列表</a>
          <i>></i>
          <a href="javascript:;" class="cur-a">{{ deviceId ? '编辑设备' : '新增设备' }}</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="operationControl flexdc" style="align-items: flex-start;">
          <el-form ref="form" :model="formData" :rules="rules" label-width="120px" class="formBox">
            <el-form-item label="考试仓名称" prop="houseName">
              <el-input v-model="formData.houseName" placeholder="考试仓名称" disabled />
            </el-form-item>
            <el-form-item label="设备名称" prop="deviceName">
              <el-input v-model="formData.deviceName" placeholder="请输入设备名称" />
            </el-form-item>
            <el-form-item label="设备码" prop="deviceCode">
              <el-input v-model="formData.deviceCode" placeholder="请输入设备码" />
            </el-form-item>
            <el-form-item label="可选信息" prop="optInfo">
              <el-input v-model="formData.optInfo" placeholder="其他设备可选信息" />
            </el-form-item>
            <el-form-item label="设备类型" prop="deviceType">
              <el-select v-model="formData.deviceType" placeholder="请选择设备类型">
                <el-option v-for="item in deviceTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="btns" style="margin-top: 30px;">
          <el-button type="primary" class="bgc-bv" @click="save">保存</el-button>
          <el-button @click="$router.back()">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Form from "@/mixins/Form";
export default {
  name: "examination_examDeviceAddEdit",
  mixins: [Form],
  data() {
    return {
      formData: {
        deviceId: '',
        examHouseId: '',
        houseName: '',
        deviceName: '',
        deviceCode: '',
        optInfo: '',
        deviceType: '',
      },
      deviceTypeList: [],
      rules: {
        deviceName: [
          { required: true, message: '请输入设备名称', trigger: 'blur' },
        ],
        deviceCode: [
          { required: true, message: '请输入设备码', trigger: 'blur' },
        ],
        deviceType: [
          { required: true, message: '请选择设备类型', trigger: 'change' },
        ],
      },
    };
  },
  created() {
    this.dataDictionary();
  },
  mounted() {
    // 获取路由参数
    this.formData.examHouseId = this.$route.query.examHouseId;
    this.formData.houseName = this.$route.query.houseName || '';
    this.formData.deviceId = this.$route.query.deviceId || '';
    // 如果是编辑，加载设备详情
    if (this.formData.deviceId) {
      this.getDeviceDetail();
    }
  },
  methods: {
    // 获取数据字典
    dataDictionary() {
      // 设备类型
      const deviceTypeList = this.$setDictionary("EXAM_DEVICE_TYPE", "list");
      const list = [];
      for (const key in deviceTypeList) {
        list.push({
          value: key,
          label: deviceTypeList[key],
        });
      }
      this.deviceTypeList = list;
    },
    // 获取设备详情
    getDeviceDetail() {
      this.$post(`/biz/isec/exam-house/getDevice`, {
        deviceId: this.formData.deviceId,
      }, 3000, true, 6)
        .then((res) => {
          if (res.data) {
            this.formData = {
              ...this.formData,
              ...res.data,
            };
          }
        })
        .catch((err) => {
          this.$message.error('获取设备详情失败');
        });
    },
    // 保存设备信息
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {
            ...this.formData,
          };
          // 调用保存接口
          const url = this.formData.deviceId ? '/biz/isec/exam-house/modifyDevice' : '/biz/isec/exam-house/addDevice';
          this.$post(url, params, 3000, true, 6)
            .then((res) => {
              this.$message.success(res.message);
              this.$router.back();
            })
            .catch((err) => {
              this.$message.error('保存失败');
            });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.formBox {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}
.btns {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.btns button {
  margin: 0 10px;
}
</style>